import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LoadingService {

  private loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public loading: Observable<boolean> = this.loading$.asObservable();

  public get Loading(): boolean {
    return this.loading$.getValue();
  }

  public set Loading(value: boolean) {
    this.loading$.next(value);
  }

  constructor() { }
}
